import { useMatch } from '@tanstack/react-location';
import { WeaveBillPay } from '../../components';

export const WeaveBillPayPage = () => {
  const { params } = useMatch();
  const { requestId } = params;

  return <WeaveBillPay locationSlug={requestId} />;
};
